import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Nav } from './components/Nav';
import { NavButton } from './components/NavButton';
import { getTranslation } from 'common/react/utils/translations';

import { Search } from '../Search';
import { glossaryActions } from 'common/store/modules/statspro/glossary';

export const Header = ({ compseason, showCompare }) => {
    const dispatch = useDispatch();
    const showGlossaryModal = () => {
        PULSE.app.tracking.recordEvent(
            PULSE.app.common.CONSTANTS.TRACKING.EVENTS.MODAL.VIEW,
            {
                eventData: {
                    /* eslint-disable-next-line camelcase */
                    modal_name: getTranslation('label.statspro.glossary')
                }
            }
        );
        return dispatch(glossaryActions.setGlossaryModalVisibility(true));
    };

    return (
        <div className="stats-header">
            <div className="stats-header__wrapper wrapper mb-0">
                <div className="stats-header__search-wrapper">
                    <Search compseason={compseason} />
                </div>
                <div className="stats-header__nav-wrapper">
                    <Nav showCompare={showCompare} />
                </div>
                <div className="stats-header__glossary-wrapper">
                    <NavButton
                        text="Glossary"
                        icon="info-circle"
                        onClick={showGlossaryModal}
                    />
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    compseason: PropTypes.string,
    showCompare: PropTypes.bool.isRequired
};
